import Image from 'next/future/image';
import ProductSold from '../ProductSold';
import settings from '@/settings';
import sellingFast from '@/public/icons/product/sellingFast.svg';
import heart from '@/public/icons/product/heart.svg';
import useProductSoldCount from '@/lib/use-product-sold-count';

const ProductSoldInfo = ({
  mostPopularProducts,
  productName,
  psku,
}: {
  mostPopularProducts: string[];
  productName: string;
  psku: string;
}) => {
  const productSoldCount = useProductSoldCount(psku);

  const isAUStore = settings.store === 'reebelo-au';

  return (
    <>
      <ProductSold totalProductSold={productSoldCount} />
      <span className="text-xxs font-bold text-gray-700 xs:py-1 xs:text-xs ">
        {isAUStore && mostPopularProducts.includes(productName) ? (
          <span>
            <span className="relative top-[2px] mr-1 inline-flex items-center">
              <Image
                src={heart}
                alt="Most popular!"
                width={12}
                height={14}
                className="object-contain"
              />
            </span>
            Most popular!
          </span>
        ) : (
          <span>
            <span className="relative top-[2px] mr-1 inline-flex items-center">
              <Image
                src={sellingFast}
                alt="Selling Fast!"
                width={12}
                height={14}
                className="object-contain"
              />
            </span>
            Selling Fast!
          </span>
        )}
      </span>
    </>
  );
};

export default ProductSoldInfo;
